const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20action%20movie%20scene%20with%20dramatic%20golden%20explosion%20lighting%2C%20cinematic%20composition%2C%20heroic%20silhouette%20in%20warm%20amber%20backlight%2C%20film%20poster%20aesthetic%2C%20dark%20atmospheric%20background%20with%20golden%20sparks&width=800&height=450&seq=carousel-01&orientation=landscape',
    title: '2024国产动作大片盘点',
    desc: '热血沸腾的国产动作巨制，每一帧都是视觉冲击。',
    tag: '热门专题',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Romantic%20movie%20scene%20with%20warm%20sunset%20golden%20light%2C%20two%20figures%20in%20soft%20backlight%2C%20cinematic%20composition%2C%20dreamy%20film%20aesthetic%2C%20elegant%20movie%20poster%20style%2C%20gentle%20bokeh%20background&width=800&height=450&seq=carousel-02&orientation=landscape',
    title: '七夕必看浪漫爱情片',
    desc: '温馨动人的爱情故事，陪你度过每一个浪漫夜晚。',
    tag: '节日特辑',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Suspenseful%20thriller%20atmosphere%20with%20dramatic%20shadow%20play%2C%20mysterious%20figure%20in%20golden%20doorway%20light%2C%20film%20noir%20cinematic%20style%2C%20dark%20corridor%20with%20single%20light%20source%2C%20tense%20movie%20poster%20aesthetic&width=800&height=450&seq=carousel-03&orientation=landscape',
    title: '烧脑悬疑片单推荐',
    desc: '层层反转的国产悬疑佳作，挑战你的推理极限。',
    tag: '编辑精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Joyful%20comedy%20movie%20scene%20with%20bright%20warm%20lighting%2C%20lively%20group%20celebration%20atmosphere%2C%20cinematic%20golden%20hour%20glow%2C%20cheerful%20film%20poster%20style%2C%20vibrant%20colors%20with%20soft%20amber%20highlights&width=800&height=450&seq=carousel-04&orientation=landscape',
    title: '周末轻松喜剧专场',
    desc: '解压神片一网打尽，让你从周一笑到周日。',
    tag: '周末推荐',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm">精心策划的影视专题，发现更多好片</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl overflow-hidden group cursor-pointer hover:scale-[1.01] transition-transform duration-300"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100/90 via-transparent to-transparent"></div>
                <span className="absolute top-4 left-4 px-3 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-lg font-heading text-foreground-950 mb-2">{item.title}</h3>
                <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}